import React from 'react'
import './PortraitApp.css'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
} from 'react-router-dom'
import PortCustomTitleBar from './common/PortCustomTitleBar.js'
import PortMenu from './common/PortMenu.js'
import PortContactPop from './common/PortContactPop.js'
import PortMainPage from './page/PortMainPage.js'
import PortProductDetailPage from './page/PortProductDetailPage.js'
import PortProductListPage from './page/PortProductListPage.js'
import PortIndustryDetailPage from './page/PortIndustryDetailPage.js'
import PortCompanyPage from './page/PortCompanyPage.js'
import PortCertificatesPage from './page/certificate/PortCertificatesPage.js'
import PortContactPage from './page/PortContactPage.js'
import PortProductLinePage from './page/innovation/PortProductLinePage.js'
import PortOverallSolutionPage from './page/innovation/PortOverallSolutionPage.js'
import PortOnsiteGuidancePage from './page/innovation/PortOnsiteGuidancePage.js'
import PortContractTermsPage from './page/PortContractTermsPage.js'
import PortPrivacyPolicyPage from './page/PortPrivacyPolicyPage.js'
import PortThirdPartySDKsPage from './page/PortThirdPartySDKsPage.js'

class PortraitApp extends React.Component {
  constructor(props) {
    super(props)
    this.state = { menuExpanded: false }
    this.titleBarRef = React.createRef()
  }

  render() {
    return (
      <div className="Portrait">
        <PortCustomTitleBar
          titleBarRef={this.titleBarRef}
          menuExpanded={this.state.menuExpanded}
          changeMenuExpandedState={this.changeMenuExpandedState}
          collapseMenu={this.collapseMenu}
          {...this.props}
        />

        <PortMenu
          menuExpanded={this.state.menuExpanded}
          handleCollapse={this.collapseMenu}
          {...this.props}
        />

        <PortContactPop />

        <Switch>
          <Route
            exact
            path="/"
            render={(props) => <PortMainPage {...props} />}
          />
          <Route
            exact
            path="/product"
            render={(props) => <PortProductDetailPage {...props} />}
          />
          <Route
            exact
            path="/product_list"
            render={(props) => <PortProductListPage {...props} />}
          />
          <Route
            exact
            path="/industry"
            render={(props) => <PortIndustryDetailPage {...props} />}
          />
          <Route
            exact
            path="/company"
            render={(props) => <PortCompanyPage {...props} />}
          />
          <Route
            exact
            path="/certificates"
            render={(props) => <PortCertificatesPage {...props} />}
          />
          <Route
            exact
            path="/contact"
            render={(props) => <PortContactPage {...props} />}
          />
          <Route
            exact
            path="/product_line"
            render={(props) => <PortProductLinePage {...props} />}
          />
          <Route
            exact
            path="/overall_solution"
            render={(props) => <PortOverallSolutionPage {...props} />}
          />
          <Route
            exact
            path="/onsite_guidance"
            render={(props) => <PortOnsiteGuidancePage {...props} />}
          />
          <Route
            exact
            path="/contract_terms"
            render={(props) => <PortContractTermsPage {...props} />}
          />
          <Route
            exact
            path="/privacy_policy"
            render={(props) => <PortPrivacyPolicyPage {...props} />}
          />
          <Route
            exact
            path="/thirdparty_sdks"
            render={(props) => <PortThirdPartySDKsPage {...props} />}
          />
        </Switch>
      </div>
    )
  }

  changeMenuExpandedState = () => {
    this.setState({
      menuExpanded: !this.state.menuExpanded,
    })
  }

  collapseMenu = () => {
    this.setState({
      menuExpanded: false,
    })
  }
}

export default withRouter(PortraitApp)
